import type { RETRIEVAL_STRATEGY } from '../constants';
import type { RetrievalResult } from '../types';

/**
 * 检索进度服务
 * @description 检索进度服务，用于记录检索进度。并将结果存储于 {@link FtoReportRetrievalProgressModel} 中
 */
export interface FtoReportRetrievalProgressService {
    /**
     * 添加进度
     * @param name 进度名称
     * @param running 进度是否正在运行
     */
    add(name: RETRIEVAL_STRATEGY, running: boolean): void;
    /**
     * 获取检索中的策略
     * @returns 检索中的策略
     */
    getRunningStrategies(): RETRIEVAL_STRATEGY[];
    /**
     * 更新检索结果
     * @param name 检索策略名称
     * @param result 检索结果
     */
    updateResult(name: RETRIEVAL_STRATEGY, result: RetrievalResult): void;
    /**
     * 将所有检索结果状态设置为完成
     */
    setAllResultFinished(): void;
}

export const FtoReportRetrievalProgressService = Symbol.for('FtoReportRetrievalProgressService');
